function SalaryRangeInputs({ low, high, onLowChange, onHighChange }) {
  return (
    <div className="flex flex-row items-center gap-3 w-full min-w-0">
      <div className="flex-1 min-w-0">
        <input
          className="sketch-input w-full max-w-full min-w-0 box-border"
          type="number"
          value={low}
          onChange={onLowChange}
          placeholder="Low"
          min="0"
        />
      </div>
      <div className="flex-1 min-w-0">
        <input
          className="sketch-input w-full max-w-full min-w-0 box-border"
          type="number"
          value={high}
          onChange={onHighChange}
          placeholder="High"
          min="0"
        />
      </div>
    </div>
  );
}

function salaryRangeValues(value) {
  const range = parseSalaryRange(value);
  if (range) {
    return {
      low: String(range.low / 1000),
      high: range.low === range.high ? '' : String(range.high / 1000),
    };
  }

  return {
    low: '',
    high: '',
  };
}

function salaryRangeValue(low, high) {
  if (low && high) return `$${low} - $${high}`;
  if (low) return `$${low}`;
  if (high) return `$${high}`;
  return '';
}

function FormFields({ value, onChange }) {
  const f   = value;
  const set = (k) => (e) => onChange({ ...f, [k]: e.target.value });

  return (
    <>
      <div className="row2">
        <div className="field">
          <label>Company *</label>
          <input className="sketch-input" value={f.company || ''} onChange={set('company')} placeholder="Acme Co." />
        </div>
        <div className="field">
          <label>Job title</label>
          <input className="sketch-input" value={f.title || ''} onChange={set('title')} placeholder="Senior Product Designer" />
        </div>
      </div>

      <div className="row2">
        <div className="field modal-date-field">
          <label>Date applied</label>
          <div className="modal-date-clip w-full max-w-full min-w-0 overflow-hidden">
            <input className="sketch-input modal-date-input w-full max-w-full min-w-0 box-border appearance-none overflow-hidden" type="date" value={f.date || ''} onChange={set('date')} />
          </div>
        </div>
        <div className="field">
          <label>Status</label>
          <select className="sketch-input" value={f.status || 'waiting'} onChange={set('status')}>
            {STATUSES.map(s => <option key={s.id} value={s.id}>{s.label}</option>)}
          </select>
        </div>
      </div>

      <div className="row2">
        <div className="field">
          <label>Salary Range</label>
          <input className="sketch-input" value={f.salary || ''} onChange={(e) => onChange({ ...f, salary: e.target.value })} onBlur={(e) => onChange({ ...f, salary: formatSalaryValue(e.target.value) })} placeholder="e.g. $150k – $180k" />
        </div>
        <div className="field">
          <label>Contact name</label>
          <input className="sketch-input" value={f.contactName ?? f.contact ?? ''} onChange={set('contactName')} placeholder="Recruiter, hiring manager, or referral name" />
        </div>
      </div>

      <div className="row2">
        <div className="field">
          <label>Contact email</label>
          <input className="sketch-input" type="email" value={f.contactEmail || ''} onChange={set('contactEmail')} placeholder="recruiter@company.com" />
        </div>
        <div className="field">
          <label>Contact LinkedIn</label>
          <input className="sketch-input" value={f.contactLinkedIn || ''} onChange={set('contactLinkedIn')} placeholder="linkedin.com/in/…" />
        </div>
      </div>

      <div className="row2">
        <div className="field">
          <label>Sent email?</label>
          <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', marginTop: 2 }}>
            <input
              type="checkbox"
              checked={!!f.sentEmail}
              onChange={(event) => {
                const checked = event.target.checked;
                onChange({ ...f, sentEmail: checked, sentEmailDate: checked ? todayISO() : '' });
              }}
              style={{ accentColor: 'var(--accent)', width: 16, height: 16 }}
            />
            <span style={{ fontSize: 14 }}>Email sent</span>
          </label>
        </div>
        <div className="field modal-date-field">
          <label>Sent email date</label>
          <div className="modal-date-clip w-full max-w-full min-w-0 overflow-hidden">
            <input className="sketch-input modal-date-input w-full max-w-full min-w-0 box-border appearance-none overflow-hidden" type="date" value={f.sentEmailDate || ''} onChange={(e) => onChange({ ...f, sentEmailDate: e.target.value })} />
          </div>
        </div>
      </div>

      <div className="field">
        <label>Link to JD</label>
        <input className="sketch-input" value={f.link || ''} onChange={set('link')} placeholder="https://…" />
      </div>

      <div className="field">
        <label>Notes</label>
        <textarea className="sketch-input" rows={1} style={{ resize: 'vertical' }} value={f.notes || ''} onChange={set('notes')} placeholder="anything to remember…" />
      </div>

      <label className="favorite-toggle">
        <input
          type="checkbox"
          checked={!!f.favorite}
          onChange={(event) => onChange({ ...f, favorite: event.target.checked })}
        />
        <span className="material-icons favorite-heart">auto_awesome</span>
        <span>{f.favorite ? 'Favorited' : 'Add to favorites'}</span>
      </label>
    </>
  );
}

function DetailDrawer({ job, onClose, onSave, onDelete }) {
  const { useState, useEffect } = React;
  const [j, setJ] = useState(job);

  const saveJob = () => {
    onSave(j);
  };

  useEffect(() => setJ(job), [job?.id]);

  return (
    <>
      <div className="scrim drawer-scrim" onClick={onClose}></div>

      <aside
        className="detail sketch-box"
        onClick={(event) => event.stopPropagation()}
        style={{
          borderRadius: 0,
          boxShadow: '-18px 0 45px rgba(0,0,0,0.1)',
          border: 'none',
        }}
      >
        <div className="detail-scroll">
          <div style={{ marginBottom: 16 }}>
            <h2 style={{ display: 'flex', alignItems: 'center', gap: 6 }}>{j.favorite && <span className="material-icons favorite-heart">auto_awesome</span>}{j.company || 'application'}</h2>
          </div>

          <FormFields value={j} onChange={setJ} />

          {safeHref(j.link) && (
            <div className="listing-action">
              <a className="candy-btn link-yellow" href={safeHref(j.link)} target="_blank" rel="noreferrer">
                Go to Listing Page
              </a>
            </div>
          )}
        </div>

        <div className="detail-actions">
          <hr className="sketch-line" />
          <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8 }}>
            <button
              className="sketch-btn"
              onClick={() => { if (confirm('Delete this application?')) onDelete(j.id); }}
              style={{ color: '#DC2626', borderColor: '#DC2626' }}
            >
              delete
            </button>
            <div style={{ display: 'flex', gap: 8 }}>
              <button className="sketch-btn" onClick={onClose}>close</button>
              <button className="sketch-btn primary drawer-save" onClick={saveJob}>save</button>
            </div>
          </div>
        </div>
      </aside>
    </>
  );
}
